import AsyncStorage from '@react-native-async-storage/async-storage';
import AuthenticationApi from './AuthenticationApi.web';

import CalCalDataApi from './CalCalDataApi'; //for demo

import jwt_decode from 'jwt-decode';

/*
This web version does not store data (could perhaps store some in localstorage??)

Instead it makes sure getUserAsync() will either get you the code or

*/

const Keys = {
	User: 'CalCalUser',
	Creds: 'CalCalCreds',
	Pin: 'CalCalUserPIN',
	Token: 'CalCalJWTToken'
};

export default class LocalStorage {
	static async getUserAsync() {
		if (__DEV__) return { access_token: 'qhqq5c4mxqp0bgq22dcbnp9aqy8vuq30r0gfitd8', refreshTime: '1612474383' }; //get this from https://app.calc.al/dev.php

		//the index.php will not be refreshed, so we need to maintain refreshTime to know when to redirect to /login for a little trip. That happens in pin screen!!

		return { access_token: 'in-your--serveronly-https-cookie', refreshTime: '9999999999' };
	}

	static async saveUserAsync(user: Object) {
		if (__DEV__) console.log('saveUserAsync', user);
		//return AsyncStorage.setItem(Keys.User, JSON.stringify(user));
		//return store.setItemAsync(Keys.User, JSON.stringify(user));
	}

	static async saveJWT(jwt) {
		//this is only in web version!
		AsyncStorage.setItem(Keys.Token, JSON.stringify(jwt.token));
	}
	static async getJWT(jwt) {
		const savedToken = await AsyncStorage.getItem(Keys.Token);

		if (savedToken) {
			//console.log('getJWT asyncStorage', savedToken);
			const jwt = JSON.parse(savedToken);
			if (!jwt || jwt.expires < new Date().getTime() / 1000) {
				AsyncStorage.removeItem(Keys.Token);
				return {};
			}
			const userinfo = jwt_decode(jwt.token);
			return { token: jwt, info: userinfo };
		} else {
			//demo: PHP just sets a cookie that we can read with the number
			var demo = document.cookie.indexOf('demo');
			if (demo > -1) {
				demo = document.cookie.substr(demo).split(';')[0].split('=')[1];
				const res = await CalCalDataApi.demoLogin(demo);
				if (__DEV__) console.log(res); //then onSuccess
				if (res.token) {
					var userinfo = jwt_decode(res.token);
					return { token: res, info: userinfo };
				}
			}
			//nothing - will stay on PIN
			return false;
		}
	}
	static async saveCredsAsync(vals) {
		return;
	}
	static async removeCredsAsync() {
		//return AsyncStorage.removeItem(Keys.User);
		return;
	}

	static async getCredsAsync() {
		return null;
	}

	static async removeUserAsync() {
		return AsyncStorage.removeItem(Keys.Token);
	}

	static async savePinAsync(val) {
		return;
	}
	static async removePinAsync() {
		//return AsyncStorage.removeItem(Keys.User);
		return;
	}

	static async getPinAsync() {
		return null;
	}

	static async saveInitLoad(username, info) {
		__DEV__ && console.log('SAVE Localstorage', Keys.InitLoad + '--' + username.replace('@', '').replace(' ', ''));
		return AsyncStorage.setItem(Keys.InitLoad + '--' + username.replace('@', '').replace(' ', ''), JSON.stringify(info));
	}

	static async getInitLoad(username) {
		//if (__DEV__) console.log('getting secureStore ' + username.replace('@', '').replace(' ', ''));
		let result;
		try {
			result = await AsyncStorage.getItem(Keys.InitLoad + '--' + username.replace('@', '').replace(' ', ''));
			return JSON.parse(result);
		} catch (e) {
			return null;
		}
	}

	static async saveNavState(state) {
		return;
		//console.log('SAVING STATE', state);
		//if (state.routes[state.index].name == 'Pin') return; //dont save
		//return AsyncStorage.setItem(Keys.NavState, JSON.stringify(state));
	}

	static async getNavState() {
		return;
		//var savedState = await AsyncStorage.getItem(Keys.NavState);
		//return savedState ? JSON.parse(savedState) : undefined;
	}
}
